import React from 'react';
import { I_IQPlayerGallery, I_IQPlayerGalleryWrapper } from './interfaces';
import IqpsImages from './components/iqps-images';
import IqpsAudio from './components/iqps-audio';
import { isMobile } from '../../../../domain/common';
import Gallery from '../../../galleries/gallery/gallery';

interface IOnlineMasteringAudioPlayerAppProps {
    iQPlayerGalleryWrapper: I_IQPlayerGalleryWrapper;
}

const OnlineMasteringAudioPlayerApp = (props: IOnlineMasteringAudioPlayerAppProps) => {

    /*useEffect(() => {
        const handleStopOther = () => {
           // console.log('STOP_PLAY_OTHER_EVENT');
        };

        document.addEventListener(STOP_PLAY_OTHER_EVENT, handleStopOther);

        return () => document.removeEventListener(STOP_PLAY_OTHER_EVENT, handleStopOther);
    }, []);*/

    /*
     desktopItemsPerSlide={ props?.iQPlayerGalleryWrapper.iQPlayerGallerySettings.itemsPerSlide_d }
     tableItemsPerSlide={ props?.iQPlayerGalleryWrapper.iQPlayerGallerySettings.itemsPerSlide_t }
     mobileItemsPerSlide={ props?.iQPlayerGalleryWrapper.iQPlayerGallerySettings.itemsPerSlide_m }
     */

    return (
        <div className="iq-player-wrapper text-white">

            <div>
                <Gallery
                    adaHideNonVisibleSlides={ true }
                    galleryStaticContentClasses=""
                    galleryStaticContentArrowClasses="mb-0"
                    allowVerticalScrolling={ true }

                    desktopItemsPerSlide={ 4 }
                    tableItemsPerSlide={ 2.5 }
                    mobileItemsPerSlide={ 1.2 }

                    codeName="cp"
                    items={ props?.iQPlayerGalleryWrapper.iQPlayerGallery }
                    loop={ false }
                    classes="w-full"
                    gap={ isMobile() ? 4 : 1 }
                    duration={ 1500 }

                    isArrowsOverflow={ false }
                    hideButtons={ true }
                    arrowsColor="white"

                    renderItem={(item: I_IQPlayerGallery) => {
                        return (
                           <div className="px-1 py-2 md:px-4 md:py-6 transition-transform duration-150 hover:scale-105" key={ `index-${ item.runID }`}>
                               {
                                   props?.iQPlayerGalleryWrapper.iQPlayerGallerySettings.type === 'audio' &&
                                   <IqpsAudio
                                       runID={ item.runID }
                                       iQPlayerGallerySettings={ props?.iQPlayerGalleryWrapper.iQPlayerGallerySettings }
                                       item={ item }
                                   />
                               }

                               {
                                   props?.iQPlayerGalleryWrapper.iQPlayerGallerySettings.type === 'images' &&
                                   <IqpsImages
                                       iQPlayerGallerySettings={ props?.iQPlayerGalleryWrapper.iQPlayerGallerySettings }
                                       item={ item }
                                   />
                               }
                           </div>
                        )
                    }}
                />
            </div>
        </div>
    );
};

export default OnlineMasteringAudioPlayerApp;